import * as Yup from 'yup';
import { Formik } from 'formik';
import React from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { FormField } from 'components/layout/form-fields/FormField';
import { applicantHistoryStore } from '../ApplicantHistoryStore';

const ValidationSchema = Yup.object().shape({
	description: Yup.string().label('Description')
});

export class ApplicantHistoryEdit extends ModalComponent {
	getInitialValues() {
		return {
			description: this.props.history.description || ''
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.update(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'ApplicantHistoryEdit')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<div className="columns">
				<div className="column is-full">
					<FormField
						className="has-text-left"
						label="Description"
						field="description"
						type="textarea"
						placeholder="Description"
						maxlength={2500}
					/>
				</div>
			</div>
		);
	}

	async update(values) {
		applicantHistoryStore
			.updateHistory(this.props.applicantId, this.props.history.id, {
				history: {
					description: values.description
				}
			})
			.then(result => {
				this.resultNotification(result, 'history', 'Update');
			});
	}
}
